export default __webpack_public_path__ + "static/media/ic_olympus.0b15337e.svg";